import { render, staticRenderFns } from "./AccountAddressBook.vue?vue&type=template&id=0301e796&scoped=true&"
import script from "./AccountAddressBook.vue?vue&type=script&lang=js&"
export * from "./AccountAddressBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0301e796",
  null
  
)

export default component.exports